import { createFileRoute, Link } from "@tanstack/react-router";
import { Logo } from "@/components/intel/Logo";

export const Route = createFileRoute("/refund-policy")({
  head: () => ({
    meta: [
      { title: "Refund Policy · CARIO INTEL" },
      { name: "description", content: "30-day money-back guarantee for CARIO INTEL subscriptions. Refunds processed by Paddle, our Merchant of Record." },
    ],
  }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-panel-border bg-background/70 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-4xl items-center px-4 sm:px-6">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="ml-auto text-sm text-muted-foreground hover:text-foreground">← Back to home</Link>
        </div>
      </header>
      <article className="mx-auto max-w-3xl px-4 sm:px-6 py-12 prose prose-invert">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan">// Legal</p>
        <h1 className="font-display text-4xl mt-3">Refund Policy</h1>
        <p className="text-sm text-muted-foreground mt-2">Last updated: June 13, 2026</p>

        <h2 className="font-display text-xl mt-10">30-day money-back guarantee</h2>
        <p>CARIO Intelligence Oy offers a <strong>30-day money-back guarantee</strong> on subscriptions to the CARIO INTEL platform. If you are not satisfied with your purchase, you can request a full refund within <strong>30 days</strong> of your order date — no questions asked.</p>

        <h2 className="font-display text-xl mt-8">Free trial</h2>
        <p>Every paid plan starts with a 1-day free trial. A valid payment card is required to start the trial. You will not be charged if you cancel before the trial period ends.</p>

        <h2 className="font-display text-xl mt-8">How to request a refund</h2>
        <p>Refunds are processed by our payment provider and Merchant of Record, <strong>Paddle</strong>. To request a refund:</p>
        <ol className="list-decimal pl-6 space-y-1">
          <li>Visit <a className="text-cyan hover:underline" href="https://paddle.net" target="_blank" rel="noreferrer">paddle.net</a> and look up your order using the email address you used at checkout.</li>
          <li>Open the relevant transaction and choose "Request a refund", or contact Paddle support from that page.</li>
          <li>Alternatively, email our team at <a className="text-cyan hover:underline" href="mailto:support@carionexus.com">support@carionexus.com</a> and we will coordinate the refund with Paddle.</li>
        </ol>

        <h2 className="font-display text-xl mt-8">After the 30-day window</h2>
        <p>After the 30-day window, refunds are handled on a case-by-case basis in line with Paddle's <a className="text-cyan hover:underline" href="https://www.paddle.com/legal/refund-policy" target="_blank" rel="noreferrer">refund policy</a> and applicable consumer protection laws in your jurisdiction.</p>

        <h2 className="font-display text-xl mt-8">Cancellations</h2>
        <p>You can cancel your subscription at any time from the customer portal. After cancellation you will retain access until the end of your current billing period and will not be charged for renewals.</p>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/terms" className="text-cyan hover:underline">Terms of Service</Link>
          <Link to="/privacy" className="text-cyan hover:underline">Privacy Notice</Link>
        </div>
      </article>
    </div>
  );
}